import React, { useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import ConventionList from '../components/student/ConventionList';
import ConventionForm from '../components/student/ConventionForm';
import StudentProfile from '../components/student/StudentProfile';

export default function StudentPage() {
  return (
    <Routes>
      <Route path="/" element={<StudentHome />} />
      <Route path="/new" element={<NewConvention />} />
      <Route path="/convention/:id" element={<EditConvention />} />
    </Routes>
  );
}

function StudentHome() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('conventions');

  return (
    <div>
      <div className="flex gap-2 mb-6 border-b border-gray-200">
        {[
          { id: 'conventions', label: 'Mes conventions' },
          { id: 'profile', label: 'Mon profil' },
        ].map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`pb-3 px-1 text-sm font-medium border-b-2 transition-colors ${
              tab === t.id ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'conventions' && <ConventionList onNew={() => navigate('/student/new')} />}
      {tab === 'profile' && <StudentProfile />}
    </div>
  );
}

function NewConvention() {
  const navigate = useNavigate();
  const location = useLocation();
  const { periodeId, classeId } = location.state || {};
  return (
    <ConventionForm
      initialPeriodeId={periodeId}
      initialClasseId={classeId}
      onSaved={() => navigate('/student')}
      onCancel={() => navigate('/student')}
    />
  );
}

function EditConvention() {
  const navigate = useNavigate();
  const id = window.location.pathname.split('/').pop();
  return (
    <ConventionForm
      conventionId={id}
      onSaved={() => navigate('/student')}
      onCancel={() => navigate('/student')}
    />
  );
}
